"use strict";

var _regeneratorRuntime = require("/drone/src/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/drone/src/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/drone/src/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var auth_events_1 = __importDefault(require("./auth.events"));

var AuthInterceptor = /*#__PURE__*/function () {
  function AuthInterceptor() {
    _classCallCheck(this, AuthInterceptor);
  }

  _createClass(AuthInterceptor, null, [{
    key: "getToken",
    value: function getToken(bootstrap) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var user;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return bootstrap.authService.getUser();

              case 2:
                user = _context.sent;

                if (!(user && !user.expired)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", user.access_token);

              case 5:
                if (!(!user || (user === null || user === void 0 ? void 0 : user.expired) && this.isRenewing)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", new Promise(function (resolve) {
                  var listen = function listen(user) {
                    resolve(user.access_token);
                    auth_events_1.default.removeListenUser(listen);
                  };

                  auth_events_1.default.addListenUser(listen);
                }));

              case 7:
                AuthInterceptor.isRenewing = true;
                _context.next = 10;
                return bootstrap.getUser();

              case 10:
                user = _context.sent;
                AuthInterceptor.isRenewing = false;
                return _context.abrupt("return", user.access_token);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return AuthInterceptor;
}();

exports.default = AuthInterceptor;
AuthInterceptor.isRenewing = false;